import { Component, Input, OnInit, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { LanguageStateService } from '../services/language-state.service';


@Component({
    selector: 'app-translate',
    template: '{{ translatedText }}',
    standalone: false
})
export class TranslateComponent implements OnInit, OnDestroy {
    @Input() key: string = '';
    translatedText: string = '';
    private subscription: Subscription | null = null;
    languageService = inject(LanguageStateService);
    constructor() { }

    ngOnInit(): void {
        this.subscription = this.languageService.currentLanguage$.subscribe(() => {
            this.translatedText = this.languageService.getTranslation(this.key);
        });
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}